import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, homePathFor } from "../context/AuthContext";
import { LogOut, Home, FilePlus2, ClipboardCheck, Landmark, Scale, Settings } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Layout() {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/connexion");
  };

  const navItems = [];
  if (hasRole("demandeur")) {
    navItems.push({ to: "/accueil", label: "Accueil", icon: Home, testid: "nav-home" });
    navItems.push({ to: "/nouvelle-note", label: "Nouvelle note", icon: FilePlus2, testid: "nav-new-report" });
  }
  if (hasRole("valideur")) navItems.push({ to: "/validation", label: "Validation", icon: ClipboardCheck, testid: "nav-validation" });
  if (hasRole("eveque")) navItems.push({ to: "/arbitrage", label: "Arbitrage", icon: Scale, testid: "nav-arbitration" });
  if (hasRole("comptable")) navItems.push({ to: "/comptabilite", label: "Comptabilité", icon: Landmark, testid: "nav-accounting" });
  if (hasRole("admin", "super_admin")) navItems.push({ to: "/admin", label: "Administration", icon: Settings, testid: "nav-admin" });

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-24 sm:pb-0">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-4">
          <Link to={homePathFor(user)} className="flex items-center gap-3" data-testid="header-logo-link">
            <img src="/assets/favicon.png" alt="Logo du Diocèse de Pamiers" className="h-10 w-10" />
            <div className="leading-tight">
              <p className="font-bold text-[#0369a1] text-lg" style={{ fontFamily: "Work Sans" }}>Notes de frais</p>
              <p className="text-xs text-slate-500 font-medium">Diocèse de Pamiers</p>
            </div>
          </Link>
          <nav className="hidden sm:flex items-center gap-1 ml-6">
            {navItems.map((item) => (
              <Link key={item.to} to={item.to} data-testid={item.testid}>
                <span
                  className={`flex items-center gap-2 px-4 h-12 rounded-xl text-base font-semibold transition-colors ${
                    location.pathname.startsWith(item.to) ? "bg-sky-100 text-[#0369a1]" : "text-slate-600 hover:bg-slate-100"
                  }`}
                >
                  <item.icon className="h-5 w-5" aria-hidden="true" strokeWidth={2.5} />
                  {item.label}
                </span>
              </Link>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-slate-800" data-testid="header-user-name">
                {user?.first_name} {user?.last_name}
              </p>
            </div>
            <Button variant="outline" onClick={handleLogout} data-testid="logout-button" className="h-12 rounded-xl border-2 font-semibold">
              <LogOut className="h-5 w-5 mr-2" aria-hidden="true" strokeWidth={2.5} />
              Déconnexion
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-6 sm:py-8">
        <Outlet />
      </main>

      <nav className="sm:hidden fixed bottom-0 left-0 right-0 h-20 bg-white border-t-2 border-slate-200 flex justify-around items-center z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        {navItems.slice(0, 4).map((item) => (
          <Link key={item.to} to={item.to} data-testid={`mobile-${item.testid}`} className="flex flex-col items-center gap-1 px-2">
            <item.icon
              className={`h-7 w-7 ${location.pathname.startsWith(item.to) ? "text-[#0369a1]" : "text-slate-400"}`}
              aria-hidden="true" strokeWidth={2.5}
            />
            <span className={`text-xs font-semibold ${location.pathname.startsWith(item.to) ? "text-[#0369a1]" : "text-slate-500"}`}>
              {item.label}
            </span>
          </Link>
        ))}
      </nav>
    </div>
  );
}
